import { gql } from "@apollo/client";

export const CREATE_PERSON = gql`
    mutation createPerson($data: CreatePatientsInput!) {
        createPerson(data: $data) {
            id
            name
            region
            city
            cpf
            rg
            age
            birth_date
            is_actived
            is_deleted
        }
    }
`;

export const UPDATE_PERSON = gql`
    mutation updatePerson($data: UpdatePatientsInput!) {
        updatePerson(data: $data) {
            id
            name
            region
            city
            cpf
            rg
            age
            birth_date
            is_actived
            is_deleted
        }
    }
`;

export default CREATE_PERSON;
